import editUsersPemissionsFormModel from './editUsersPemissionsFormModel';
const {
  formField: {
    // DATOS USUARIOS PERMISOS 
    usersPemissionsEdit
  } 
} = editUsersPemissionsFormModel;

export default {
  [usersPemissionsEdit.name]: '',
};

